import type { RootState } from '@/_store/store';

export const selectMotoboyInfo = (state: RootState) =>
  state.motoboyInfo.payload;
export const selectDedication = (state: RootState) =>
  state.motoboyInfo.dedication;
export const selectLastMotoboyDedication = (state: RootState) =>
  state.motoboyInfo.lastMotoboyIdDedication;
